import { SPONSOR_MODE } from '../config';

/**
 * Determines if the current experience should render the sponsor UI.
 * Returns true if:
 * - The hostname contains "sponsor" (e.g., staging.sponsor.app.quoiden.com, sponsor.app.quoiden.com)
 * - OR VITE_SPONSOR_MODE is set to "true" (for local development)
 */
export const isSponsorExperience = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname.includes('sponsor') || SPONSOR_MODE;
};
